<script setup>
import {ref} from "vue";
import VoiceThemeInformationContainer from "./VoiceThemeInformationContainer.vue";
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  voiceTheme: {
    type: Object,
    required: true,
  }
});
const emits = defineEmits(['request-close', 'request-submit', 'update-field', 'request-valid']);

// 編集モード
const isEdit = ref(true);
</script>

<template>
  <div v-if="isShow">
    <div :class="{modModalWindow: true, isShow}">
      <div class="modModalTitleContainer">
        <p class="lyInlineBlock lyPt6 lyPb6 lyPr8 lyPl8 pFont12 pFontBold pFontWhite pBackColorBlue pBorderRadiusEllipse">回答受付中</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          @click="emits('request-close')"
        ><span class="lyBlock lyW24px"><img
          :src="siteUrl+'images/iconClose.svg'"
          loading="lazy"
          alt="" width="30"
          height="31"
        ></span>
          とじる
        </button>
      </div>
      <div class="modModalBottomWrapper">
        <VoiceThemeInformationContainer :voice-theme="voiceTheme" />
        <div class="lyPt16 lyPb16 lyPl8 lyPr8 lyTbPl16 lyTbPr16">
          <p class="lyMb40">ご回答いただきありがとうございます！<br>エントリーを受け付けました。</p>
          <p class="lyMb8"><button
            type="button"
            class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontWhite pBackColorGreen pBorderRadius2px pHoverSlideChange"
            @click="emits('request-close')"
          >お題に戻る</button></p>
          <p><a
            :href="siteUrl"
            class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontGreen pBackColorGray4 pBorder1pxSolidGreen pBorderRadius2px"
          >他のお題をみる</a></p>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>
